module.exports = __webpack_public_path__ + "b8c9620a4f206647d02d50668fa543fc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_21.jpg
 ** module id = 604
 ** module chunks = 0
 **/